import React, {useContext, useEffect} from "react";
import {FormContext} from "./Form";
import Select from "react-select";

export function SelectField(props) {
  const {
    opciones,
    name,
    label,
    placeholder,
    opcionPorDefecto,
    isMulti,
    isRow,
    isLoading,
    width = "200px",
    ...otrasProps
  } = props;
  const { value, setValue } = useContext(FormContext);

  if (!value) {
    return "SelectField debe este dentro de un SimpleForm";
  }

  const options = opcionPorDefecto ? [{ label: placeholder, value: -1 }, ...opciones] : opciones;

  useEffect(() => {
    var input = document.querySelector(`.react-select__input`);
    if (input) {        
      input.style.width = "200px";
    }
  }, []);
    
  return (
    <React.Fragment>
      {label && <label className={isRow ? "label" : "label"}>{label}</label>}
      <div className="control" style={{ width: width }}>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          isMulti={isMulti}
          value={value(name)}
          options={options || []}
          onChange={(value) => {
            setValue(name, value);
          }}
          placeholder={placeholder}
          noOptionsMessage={() => "No hay opciones"}
          isLoading={isLoading}
          styles={{
            control: (base) => ({
              ...base,
              minHeight: "0",
              border: "#97bdc1 solid 1px",
              boxShadow: "2px 2px 0 #d7e6e7, -2px 2px 0 #d7e6e7, 2px -2px 0 #d7e6e7, -2px -2px 0 #d7e6e7",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              padding: "0 8px",
            }),
            clearIndicator: (base) => ({
              ...base,
              padding: "0 8px",
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
          }}
        />
      </div>
    </React.Fragment>
  );
}
